import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/best-fit-spread";

export const fetchBestFitSpread = createAsyncThunk(
  "bestFitSpread/fetch",
  async (_, { getState }) => {
    const { filters } = getState().capture.dashboard;
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  }
);
